import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import classnames from 'classnames';
import { Component, Fragment } from '@wordpress/element';
import PropTypes from 'prop-types';
/**
 * Internal dependencies
 */

import Spinner from '../spinner';
import CheckIcon from './check-icon';
/**
 * A stepper component to indicate progress in a set number of steps.
 */

var Stepper =
/*#__PURE__*/
function (_Component) {
  _inherits(Stepper, _Component);

  function Stepper() {
    _classCallCheck(this, Stepper);

    return _possibleConstructorReturn(this, _getPrototypeOf(Stepper).apply(this, arguments));
  }

  _createClass(Stepper, [{
    key: "renderCurrentStepContent",
    value: function renderCurrentStepContent() {
      var _this$props = this.props,
          currentStep = _this$props.currentStep,
          steps = _this$props.steps;
      var step = steps.find(function (s) {
        return currentStep === s.key;
      });

      if (!step.content) {
        return null;
      }

      return createElement("div", {
        className: "woocommerce-stepper_content"
      }, step.content);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          currentStep = _this$props2.currentStep,
          steps = _this$props2.steps,
          isVertical = _this$props2.isVertical,
          isPending = _this$props2.isPending;
      var currentIndex = steps.findIndex(function (s) {
        return currentStep === s.key;
      });
      var stepperClassName = classnames('woocommerce-stepper', className, {
        'is-vertical': isVertical
      });
      return createElement("div", {
        className: stepperClassName
      }, createElement("div", {
        className: "woocommerce-stepper__steps"
      }, steps.map(function (step, i) {
        var key = step.key,
            label = step.label,
            description = step.description,
            isComplete = step.isComplete,
            onClick = step.onClick;
        var isCurrentStep = key === currentStep;
        var stepClassName = classnames('woocommerce-stepper__step', {
          'is-active': isCurrentStep,
          'is-complete': 'undefined' !== typeof isComplete ? isComplete : currentIndex > i
        });
        var icon = isCurrentStep && isPending ? createElement(Spinner, null) : createElement("div", {
          className: "woocommerce-stepper__step-icon"
        }, createElement("span", {
          className: "woocommerce-stepper__step-number"
        }, i + 1), createElement(CheckIcon, null));
        var LabelWrapper = 'function' === typeof onClick ? 'button' : 'div';
        return createElement(Fragment, {
          key: key
        }, createElement("div", {
          className: stepClassName
        }, createElement(LabelWrapper, {
          className: "woocommerce-stepper__step-label-wrapper",
          onClick: 'function' === typeof onClick ? function () {
            return onClick(key);
          } : null
        }, icon, createElement("div", {
          className: "woocommerce-stepper__step-text"
        }, createElement("span", {
          className: "woocommerce-stepper__step-label"
        }, label), description && createElement("span", {
          className: "woocommerce-stepper__step-description"
        }, description))), isCurrentStep && isVertical && _this.renderCurrentStepContent()), !isVertical && createElement("div", {
          className: "woocommerce-stepper__step-divider"
        }));
      })), !isVertical && this.renderCurrentStepContent());
    }
  }]);

  return Stepper;
}(Component);

Stepper.propTypes = {
  /**
   * Additional class name to style the component.
   */
  className: PropTypes.string,

  /**
   * The current step's key.
   */
  currentStep: PropTypes.string.isRequired,

  /**
   * An array of steps used.
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Content displayed when the step is active.
     */
    content: PropTypes.node,

    /**
     * Description displayed beneath the label.
     */
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),

    /**
     * Optionally mark a step complete regardless of step index.
     */
    isComplete: PropTypes.bool,

    /**
     * Key used to identify step.
     */
    key: PropTypes.string.isRequired,

    /**
     * Label displayed in stepper.
     */
    label: PropTypes.string.isRequired,

    /**
     * A function to be called when the step label is clicked.
     */
    onClick: PropTypes.func
  })).isRequired,

  /**
   * If the stepper is vertical instead of horizontal.
   */
  isVertical: PropTypes.bool,

  /**
   * Optionally mark the current step as pending to show a spinner.
   */
  isPending: PropTypes.bool
};
Stepper.defaultProps = {
  isVertical: false,
  isPending: false
};
export default Stepper;
//# sourceMappingURL=index.js.map